<template>
	<div>
		<a-modal v-model="visible" title="选择用户" @ok="saveauth" width="1100px"  cancelText="取消" okText="确定" :bodyStyle="{margin:'-24px'}">
			<div style="display:flex">
				<div>
					<a-form-model layout="inline" :model="searchdata" style="padding:5px 0 5px 5px">
						<a-form-model-item  >
							<a-input placeholder="姓名" v-model="searchdata.username" allowClear style="width:120px"></a-input>
						</a-form-model-item>
						<a-form-model-item  >
							<a-input placeholder="电话" v-model="searchdata.phonenum" allowClear style="width:150px"></a-input>
						</a-form-model-item>
						<a-form-model-item  >
							<a-input placeholder="身份证号码" v-model="searchdata.idcard" allowClear style="width:220px"></a-input>
						</a-form-model-item>
						<a-form-model-item >
							<a-button type="primary" @click="find" >查询</a-button>
						</a-form-model-item>
					</a-form-model>
					<a-table 
						:columns="columns"
						:dataSource="dataSource"
						:pagination="pagination"
						:row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
						row-key="id"
					></a-table>
				</div>
				<div>
					<div style="font-size:18px;height: 50px;line-height: 50px;padding: 0 20px;">
						已选择的用户
					</div>
					<a-table 
						:columns="columns"
						:dataSource="selectedRows"
						:row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
						row-key="id"
						:pagination="{pageSize:10,total:selectedRowKeys.length}"
					></a-table>
				</div>
			</div>
			
			
		</a-modal>
	</div>
</template>



<script>
import Auth from './index.js'
export default Auth
</script>
